import { useState } from "react";
import { useQuery } from "@apollo/client";
import { List, Tag, Card, Segmented, Input, Space, Form, Button, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { getSubgraphLogs } from "../../helpers/portal.api";
import { SUBGRAPH_LOGS_QUERY } from "../../helpers/graphql/subgraph";

interface Logs {
  level: string;
  text: string;
  timestamp: string;
}

interface LogsInputValues {
  level: string;
  query: string;
}

export function SubgraphLogs({ themeColor, textColor, subgraph, indexingStatus }: any) {
  const [downloading, setDownloading] = useState(false);

  const { refetch, loading, data } = useQuery(SUBGRAPH_LOGS_QUERY, {
    variables: { level: "debug", cluster: subgraph.cluster, subgraphDeploymentId: indexingStatus?.subgraph, query: "" },
    pollInterval: 5000,
  });

  const subgraphIndexingLogs = data?.subgraphIndexingLogs as Logs[];

  const options = [
    { label: "Debug", value: "debug" },
    { label: "Info", value: "info" },
    { label: "Warning", value: "warn" },
    { label: "Error", value: "error" },
  ];

  const tagColor: any = {
    info: "blue",
    debug: "yellow",
    warning: "orange",
    error: "red",
  };

  const handleValuesChange = async (changedValues: any, allValues: LogsInputValues) => {
    refetch({
      level: allValues.level || "debug",
      query: allValues.query,
      subgraphDeploymentId: indexingStatus?.subgraph,
      cluster: subgraph.cluster,
    });
  };

  return (
    <Card
      className={"card-body"}
      title="Logs"
      extra={
        <Button
          type="primary"
          loading={downloading}
          onClick={async () => {
            try {
              setDownloading(true);
              await getSubgraphLogs(subgraph.cluster, indexingStatus?.subgraph);
            } catch (err: any) {
              message.error(err.toString());
            }
            setDownloading(false);
          }}
        >
          Export
        </Button>
      }
      headStyle={{
        backgroundColor: themeColor,
        color: textColor,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      }}
    >
      <Space direction="horizontal">
        <Form<LogsInputValues>
          id="subgraphLogsForm"
          name="subgraphLogs"
          layout="inline"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 100 }}
          onValuesChange={handleValuesChange}
          autoComplete="off"
        >
          <Form.Item name="level">
            <Segmented options={options} />
          </Form.Item>
          <Form.Item name="query">
            <Input placeholder="Search" prefix={<SearchOutlined />} />
          </Form.Item>
        </Form>
      </Space>

      {loading ? (
        <Card loading={true} className="card-loading" />
      ) : (
        <List
          style={{ overflow: "auto", height: "40vh", marginTop: 20 }}
          dataSource={subgraphIndexingLogs}
          renderItem={(item: Logs) => (
            <List.Item key={item.timestamp}>
              <List.Item.Meta
                description={
                  <span>
                    {`[${new Date(item.timestamp).toLocaleString()}] `}
                    <Tag color={tagColor[item.level]} style={{ borderRadius: 10 }}>
                      {item.level}
                    </Tag>
                    {item.text}
                  </span>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Card>
  );
}
